import { IconGift } from '@tabler/icons-react';
import {
  DAILY_CHECK_IN_ENABLED,
  REGISTER_GIFT_CREDITS,
} from '@/config/credit-economics';
import { openDailyCheckInDialog } from '@/lib/daily-check-in-dialog';
import { getLocale } from '@/lib/locale';
import { cn } from '@/lib/utils';
import { m } from '@/locale/paraglide/messages';

interface FreeCreditsButtonProps {
  callbackUrl?: string;
  className?: string;
}

export function FreeCreditsButton({
  callbackUrl,
  className,
}: FreeCreditsButtonProps) {
  const locale = getLocale();
  if (!DAILY_CHECK_IN_ENABLED) return null;
  const giftCredits = REGISTER_GIFT_CREDITS;
  return (
    <button
      type="button"
      onClick={() =>
        openDailyCheckInDialog({
          callbackUrl,
          source: 'free_credits',
        })
      }
      className={cn(
        'inline-flex h-10 shrink-0 items-center gap-2 rounded-full',
        'border border-[#e2b84e]/55 bg-[#fff1d2] px-3 text-[#17130a]',
        'font-semibold text-sm shadow-[0_10px_26px_rgba(212,175,55,0.22)]',
        'transition hover:border-[#f0d46c] hover:bg-[#fff6df]',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#d4af37]/55',
        className
      )}
    >
      <span className="inline-flex size-6 items-center justify-center rounded-full bg-white text-[#d4a012] shadow-inner ring-1 ring-[#f2d27a]/70">
        <IconGift className="size-4" />
      </span>
      <span className="rounded-full bg-white/80 px-2 py-0.5 font-bold text-[11px] tracking-normal">
        {m.free_credits_badge({}, { locale })}
      </span>
      <span className="whitespace-nowrap">
        {m.free_credits_cta({ credits: giftCredits }, { locale })}
      </span>
    </button>
  );
}
